import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
		'DateWrapper',
		{ 'ContentInvalid': !_ctx.shouldFieldBeDisabled && (_ctx.isFieldValidatedAndMissing || _ctx.isFieldValidatedAndInvalid) }
	])
  }, [
    _createElementVNode("input", {
      ref: "datePicker",
      type: "date",
      class: "CampaignEditorDatePicker",
      disabled: _ctx.shouldFieldBeDisabled,
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setDate && _ctx.setDate(...args)))
    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "DateInputLabel" }, " Start Date ", -1 /* CACHED */))
  ], 2 /* CLASS */))
}